import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ProductOverviewRequest} from '../../services/product-overview/product-overview-request.model';
import {DetailScreensRequestModel} from '../po-treeview/detail-screens-module/services/detail-screens-request.model';

@Injectable({
  providedIn: 'root',
})
export class CollateralObjectsService {
  civViewBaseUrl;
  civServicesBaseUrl;

  constructor(private readonly http: HttpClient) {
    this.civServicesBaseUrl = environment.civServicesBaseURL;
  }

  /**
   * Retrieve data from civ_services
   * @param string reqUrl  - An url for request
   * @return HttpClient Observable object
   * @example getTableData('registergoederen', '111999920150306')
   */
  public getTableData(reqUrl: string) {
    const tableDataURL = this.civServicesBaseUrl + reqUrl;
    const requestBody = { parametersToken: ProductOverviewRequest.parametersToken };
    const headers = this.createHeaders();
    return this.http.post(tableDataURL, requestBody, {headers});
  }

  /**
   * Creates the headers for request
   * @return HttpHeaders Object
   */
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', ProductOverviewRequest.token);
    headers = headers.append('MFA-Authorization', ProductOverviewRequest.token);
    headers = headers.append('Graph-Authorization', ProductOverviewRequest.graphToken);
    headers = headers.append('Content-type', 'application/json');
    return headers;
  }
}
